/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Pbs_Fb95Inputs */

const en__field_enum_pbs_fb95 = /** @type {(inputs: _Field_Enum_Pbs_Fb95Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`F 09 Faculty of Linguistics, Cultures and Arts`)
};

const de__field_enum_pbs_fb95 = /** @type {(inputs: _Field_Enum_Pbs_Fb95Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FB 09 Sprach- und Kulturwissenschaften`)
};

/**
* | output |
* | --- |
* | "F 09 Faculty of Linguistics, Cultures and Arts" |
*
* @param {_Field_Enum_Pbs_Fb95Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_pbs_fb95 = /** @type {((inputs?: _Field_Enum_Pbs_Fb95Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Pbs_Fb95Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_pbs_fb95(inputs)
	return de__field_enum_pbs_fb95(inputs)
});
export { _field_enum_pbs_fb95 as "_field_enum_PBS_FB9" }